import { RequestItemApi } from "../../RequestItem/services/types";

export interface WebhookApi {
	id: number;
	name: string;
	url: string;
	resource_type: string;
	requests: RequestItemApi[];
	settings?: WebhookSettingApi[];
}

export interface WebhookSettingApi {
	name: string;
	type: WebhookSettingType | null;
	value: string;
}

export enum WebhookSettingType {
	HEADER = "HEADER",
	PARAM = "PARAM",
}
